import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'vue-class-component/hooks';
import VueI18n from 'vue-i18n';
import VueSelect from "vue-select";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import i18nMessages from "@/i18nMessages";
import Multiselect from "vue-multiselect";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueDatepickerUi from 'vue-datepicker-ui';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueQRCodeComponent from 'vue-qrcode-component';
// import Treeselect from "@riophae/vue-treeselect"
// import "@riophae/vue-treeselect/dist/vue-treeselect.css"
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import "@/app.scss";

import VXETable from 'vxe-table';
import Tooltip  from 'vxe-table';

import 'vxe-table/lib/style.css';

import VueExcelEditor from "vue-excel-editor";

Vue.use(VueExcelEditor);

Vue.use(VXETable);

Vue.use(Tooltip);

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueI18n);

Vue.use(CKEditor);
Vue.use(VueVirtualScroller);

Vue.component("v-select", VueSelect);
Vue.component("v-multiselect", Multiselect);
Vue.component('v-datepicker', VueDatepickerUi);
Vue.component('v-chart', async () => {
  await import("@/echarts");
  return import("vue-echarts");
});

Vue.component('qr-code', VueQRCodeComponent);
// Vue.component("VueTreeselect", Treeselect)

Vue.config.productionTip = false;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: localStorage.getItem("vue-i18n-locale") || "vi", // set locale
  messages: i18nMessages, // set locale messages
});

/// 🟢 Kiểm tra domain là gomeeting.vnpt.vn => chuyển hướng về gomeet.vnpt.vn
if (window.location.hostname === 'gomeeting.vnpt.vn') {
  const newUrl = window.location.href.replace('gomeeting.vnpt.vn', 'gomeet.vnpt.vn');
  window.location.replace(newUrl);
}

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
